import WBContractABI from "../json/WBContractABI.json";
import WRLDContractABI from "../json/WRLDContractABI.json";
import FPContractABI from "../json/FPContractABI.json";
import W1ContractABI from "../json/W1ContractABI.json";
import PlayerManagerContractABI from "../json/PlayerManagerContractABI.json";
import GamePoolContractABI from "../json/GamePoolContractABI.json";
import BaccaratContractABI from "../json/BaccaratContractABI.json";
import Web32FAContractABI from "../json/Web32FAContractABI.json";

// AGE VERIFICATION CONTRACT AND ABI

export const AGE_VERIFICATION_CONTRACT_ADDRESS = "0x733C12AE85368e85c87cC3e47e421Ff714d11171";
export const AGE_VERIFICATION_CONTRACT_ABI = WBContractABI.abi;
export const WRISTBAND_WRLD_PRICE = 2;

// WRLD TOKEN CONTRACT AND ABI

export const WRLD_CONTRACT_ADDRESS = "0xd3B6d07CeF0bfF3602bc5Eb0E7771149382E45FE";
export const WRLD_CONTRACT_ABI = WRLDContractABI.abi;

// FOUNDERS PASS CONTRACT AND ABI

export const FP_CONTRACT_ADDRESS = "0x46F6BB50345d61B183C1CA4D2c794943Bc688bCB";
export const FP_CONTRACT_ABI = FPContractABI.abi;

// WAVE 1 CONTRACT AND ABI

export const W1_CONTRACT_ADDRESS = "0x8F392BDa5d1FC9d6076894295aefF9207D218d82";
export const W1_CONTRACT_ABI = W1ContractABI.abi;

// PLAYER MANAGER CONTRACT AND ABI

export const PLAYER_MANAGER_CONTRACT_ADDRESS = "0x78861D0b64C2F29C87068E77a859a55b94Cfc82b";
export const PLAYER_MANAGER_CONTRACT_ABI = PlayerManagerContractABI.abi;

// CINSITY GAME POOL CONTRACT AND ABI

export const GAME_POOL_CONTRACT_ADDRESS = "0xbDf475A3B824D252E031b4C01ce6Ae75b165eFea";
export const GAME_POOL_CONTRACT_ABI = GamePoolContractABI.abi;

// BACCARAT CONTRACT AND ABI
export const BACCARAT_CONTRACT_ADDRESS = "0x974d787ceF13D0859f232593eC8BFA8e33a605E9";
export const BACCARAT_CONTRACT_ABI = BaccaratContractABI.abi;

// WEB3 2FA CONTRACT AND ABI

export const WEB32FA_CONTRACT_ADDRESS = "0x9C298C552914CB9DA577434E94a9a9Fa6DA943f0";
export const WEB32FA_CONTRACT_ABI = Web32FAContractABI.abi;